import HeroAbout from '../components/About/HeroAbout';
import OurStory from '../components/About/OurStory';
import ProcessSection from '../components/About/ProcessSection';
import ValuesSection from '../components/About/ValuesSection';
import CTAAbout from '../components/About/CTAAbout';
import LeadershipTeam from '../components/About/LeadershipTeam';
import SEO, { SITE_URL } from '../components/SEO';

const About = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About Tantika Crafts - Bengali Handmade Craft Marketplace',
    url: `${SITE_URL}/about`,
    description:
      'Tantika Crafts is a platform connecting Bengali artisans with conscious consumers through authentic handmade sarees, jewelry, home decor, pottery, and textiles.',
    mainEntity: {
      '@type': 'Organization',
      name: 'Tantika Crafts',
      url: SITE_URL,
      email: 'tantikacustomercare@outlook.com',
      founder: [
        {
          '@type': 'Person',
          name: 'Purba Banerjee',
          jobTitle: 'Founder & CEO',
        },
        {
          '@type': 'Person',
          name: 'Aditya Mukherjee',
          jobTitle: 'Co-founder & COO',
        },
      ],
    },
  };

  return (
    <div>
      <SEO
        title="About Us - Our Story & Bengali Artisan Craft Marketplace"
        description="Learn about Tantika Crafts: our mission to preserve Bengali craftsmanship, empower local artisans, and bring authentic handmade sarees, jewelry, home decor, pottery and textiles to conscious consumers."
        keywords="about tantika crafts, bengali crafts story, indian artisan platform, handmade marketplace, fair trade crafts india, preserve bengali heritage"
        url="/about"
        type="website"
        jsonLd={jsonLd}
      />
      <HeroAbout />
      <OurStory />
      <ProcessSection />
      <ValuesSection />
      <LeadershipTeam />
      <CTAAbout />
    </div>
  );
};

export default About;
